var map = {
	"./Circle.svg": "8ff8",
	"./Diamond.svg": "3624",
	"./Heart.svg": "3b79",
	"./Hexagon.svg": "2955",
	"./Square.svg": "7046",
	"./Triangle.svg": "9315"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f22";